import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design } from '../designTest/designTest.model';
import { DesignSet } from '../edit-questionset/edit-questionset.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { Evaluate } from '../evaluate_marks/evaluate.model';
import { Overall_Result } from '../overall_result/overall_result.model';




export interface report{
    College_Id: string;
    Year_Id:string;
    Question_Set:string;
}
interface TokenResponse {
    token: string;
  }

@Injectable()
export class ReportService {

  private token: string;
  constructor(private http: HttpClient) {}
  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }




   // View Report
   public candidate_report(item:report): Observable<any> {

    const b = this.http.post('/users/report', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

    // Download Report...
   public download_report(item:report): Observable<any> {
  
    const b = this.http.post('/users/download', item,);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

    //download csv

     // Download Report..........
   public download_csv(item:report,idArray:[]): Observable<any> {
    item[`filteredIds`] = idArray
    console.log("item*********",item)
    const b = this.http.post('/users/download/report_csv', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

   // Download Report
   public download_temp(item:report): Observable<any> {

    const b = this.http.post('/users/download/candidate_error', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

    // Download temp validate questions upload
   public download_questions_upload(item:report): Observable<any> {

    const b = this.http.post('/users/download/question_error', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

// Download error report of media upload
    public download_media_upload(item:report): Observable<any> {

      const b = this.http.post('/users/download/media_upload_error', item);
      const request = b.pipe(
        map((data: TokenResponse) => {
  
          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
      }
















}



